/** Production canonical origin; falls back to window.location.origin in dev. */
export function getSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_ORIGIN?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
}
